
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kakor",
      function () {
        return require("private-next-pages/kakor.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kakor"])
      });
    }
  